import ImageLightbox from '@/js/ImageLightbox';
import { componentProvider } from 'js-component-framework/es';
import './product-image.scss';

/**
 * Handles product image lightboxes.
 *
 * @param {HTMLElement} args.element The component element.
 */
function productImages({ element }) {
  const lightbox = new ImageLightbox(element);

  /**
   * Reset the lightbox target based on the active slide.
   *
   * @param {object} Event.detail The event data.
   */
  const updateLightboxTarget = ({ detail }) => {
    const { activeSlide } = detail;

    if (undefined !== activeSlide?.dataset?.lightboxId) {
      const target = document.getElementById(activeSlide.dataset.lightboxId);
      lightbox.newTarget = target;
    }
  };

  element.parentElement.addEventListener('aiCarousel.slideChange', updateLightboxTarget);
}

/**
 * Product image component config.
 */
const productImageConfig = {
  name: 'product-image',
  component: productImages,
};

componentProvider(productImageConfig);
